import MapBoxMap from "./MapBoxMap";

export default MapBoxMap